import { uebersetze } from '../../i18n/sprache.js';

import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import { Button } from './Button.jsx';

export function Modal({ open, title, onClose, children, footer }) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    function handleKey(event) {
      if (event.key === 'Escape') {
        onClose?.();
      }
    }
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [open, onClose]);

  if (!open) {
    return null;
  }
  return createPortal(
    <div
      className="modal-backdrop"
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose?.();
        }
      }}
    >
      <div className="modal">
        <header className="modal-header">
          <h2 className="card-title">{title}</h2>
          <Button variant="ghost" size="sm" onClick={onClose} aria-label={uebersetze('aria.schliessen')}>
            ×
          </Button>
        </header>
        <div className="modal-body">{children}</div>
        {footer && <footer className="modal-footer">{footer}</footer>}
      </div>
    </div>,
    document.body,
  );
}
